<p-card>
  <div class="header">{{title}}</div>
  <p-chart type="doughnut" [data]="chartData"></p-chart>
  <div class="footer">{{footer}}</div>
</p-card>